export const JWT_TOKEN = "token"
export const CULTURE = "UserCulture"
export const NO_OF_TRIES = "not"



// WEBPACK FOOTER //
// ./src/constants/cookieNames.js